import { Box, Typography } from '@mui/material'
import ApexLogo from '../assets/apex-logo.svg'

interface WorkInProgressProps {
  title: string
}

export function WorkInProgress({ title }: WorkInProgressProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
        gap: 3,
        px: 3,
      }}
    >
      <img
        src={ApexLogo}
        alt="APEX Logo"
        style={{
          height: '120px',
          width: 'auto',
          marginBottom: '16px',
        }}
      />
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          fontSize: '24px',
          color: '#333',
          letterSpacing: '0.4px',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: '#666',
          fontSize: '16px',
          textAlign: 'center',
          maxWidth: '500px',
        }}
      >
        This section is currently under development. Please check back soon.
      </Typography>
    </Box>
  )
}

export const Component = WorkInProgress
